import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Signup() {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);
  const { register, formatApiError } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try {
      await register(form.email, form.password, form.name);
      toast.success("Account created.");
      nav("/onboarding");
    } catch (e) {
      const msg = formatApiError(e.response?.data?.detail) || e.message;
      setErr(msg); toast.error(msg);
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 md:px-12 py-16">
      <div className="label-eyebrow">Create Account</div>
      <h1 className="wordmark mt-4 text-4xl md:text-5xl uppercase">Start Rebuilding.</h1>
      <form onSubmit={submit} className="mt-8 bg-card border border-border rounded-lg p-8 space-y-4">
        <div>
          <label className="label-eyebrow">Name</label>
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="mt-2 w-full rounded-md border border-input bg-background px-3 py-2.5 outline-none focus:ring-2 focus:ring-ring" data-testid="signup-name" />
        </div>
        <div>
          <label className="label-eyebrow">Email</label>
          <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="mt-2 w-full rounded-md border border-input bg-background px-3 py-2.5 outline-none focus:ring-2 focus:ring-ring" data-testid="signup-email" />
        </div>
        <div>
          <label className="label-eyebrow">Password</label>
          <input required type="password" minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="mt-2 w-full rounded-md border border-input bg-background px-3 py-2.5 outline-none focus:ring-2 focus:ring-ring" data-testid="signup-password" />
        </div>
        {err && <div className="text-sm text-destructive">{err}</div>}
        <button disabled={busy} className="btn-primary w-full disabled:opacity-60" data-testid="signup-submit">
          {busy ? "Creating…" : "Create Account"}
        </button>
      </form>
      <p className="mt-6 text-sm text-muted-foreground">Have an account? <Link to="/login" className="text-primary underline">Log in</Link></p>
    </div>
  );
}
